import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useFinishRentSession = (onFinishSuccess: () => void) => {
  const mutation = useMutation({
    mutationFn: (id: string | number) => {
      return API.finishSession(id);
    },
    onSuccess: onFinishSuccess,
  });
  return {
    finish: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
